import React from 'react'
import { Channel } from './chaneel'
import { PlusOutlined } from '@ant-design/icons'

export const ChannelsWindow = ({
    channels, readReceipt, selectedChannel, onSelectChannel, client, personId,
    fetchCommunityMembers, setShowCommunity, loading, setLoading }) => {
    const handleNewDM = () => {
        setShowCommunity(true)
        fetchCommunityMembers()
    }
    return (
        <div className='left-container'>
            <div className='mb'>
                <p>Channels</p>
                {channels.filter((ch) => ch.t === 'p').map((channel) => {
                    const receipt = readReceipt.find((receipt) => receipt.rid === channel._id)
                    return (
                        <Channel
                            channel={channel}
                            selectedChannel={selectedChannel}
                            onSelectChannel={onSelectChannel}
                            clientId={client ? client.id : null}
                            personId={personId}
                            receipt={receipt}
                            name={channel.name.split('_')[0]}
                        />
                    )
                })}
            </div>
            <div className='mb'>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '14px' }}>
                    <div style={{ marginRight: '8px' }}>Direct Messages</div>
                    {client ? (<></>) : (<PlusOutlined style={{ cursor: 'pointer' }} onClick={handleNewDM} />)}
                </div>
                {channels.filter((ch) => ch.t === 'd').map((dm) => {
                    const receipt = readReceipt.find((receipt) => receipt.rid === dm._id)
                    return (
                        <Channel
                            channel={dm}
                            selectedChannel={selectedChannel}
                            onSelectChannel={onSelectChannel}
                            clientId={client ? client.id : null}
                            personId={personId}
                            receipt={receipt}
                            name={dm.name.split('_')[0]}
                            isDm={true}
                        />
                    )
                })}
            </div>
        </div>
    )
}
